// @flow
import type { AxiosPromise } from 'axios';
import AxiosClient from '../AxiosClient';

export default class NotificationSettingsClient extends AxiosClient {
  updateSetting(key: string, value: boolean): AxiosPromise<Object> {
    return this.client.put('my/company/notification_setting', {
      notificationSetting: {
        [key]: value,
      },
    });
  }
}
